export default __webpack_public_path__ + "static/media/2410271.eab47acc.jpg";